import { AxiosCallPostWithErr } from './apicall'
import { ReferentialStore } from '@/stores'

/**
 * Referentiel Lynx
 */
/**
 * Service to access Lynx API authentication.
 */
export default class ReferentialService {
  /**
   * Constructor.
   * @param {string} baseUrl Base url to connect to lynx API. typically http or https//[ip]/lynxapi
   */
  constructor (baseUrl) {
    this.baseUrl = baseUrl
  }

  // Fonction pour trier un tableau d'objets basé sur une clé spécifique en insensible à la casse
  sortArrayByKey (array, key) {
    array.sort((a, b) => {
      const labelA = a[key].toLowerCase()
      const labelB = b[key].toLowerCase()
      return labelA.localeCompare(labelB)
    })
    return array
  }

  async InitReferential () {
    const err1 = await AxiosCallPostWithErr('lynxapi/referential/candidatestates', null,
      (res) => {
        ReferentialStore().CandidateStates = res
      })
    const localthis = this
    const err2 = await AxiosCallPostWithErr('lynxapi/referential/skills', null,
      (skills) => {
        ReferentialStore().Skills = localthis.sortArrayByKey(skills, 'name')
      })
    const err3 = await AxiosCallPostWithErr('lynxapi/referential/positiontypes', null,
      (postypes) => {
        ReferentialStore().PositionTypes = localthis.sortArrayByKey(postypes, 'label')
      })
    const err4 = await AxiosCallPostWithErr('lynxapi/referential/oppstates', null,
      (opst) => {
        ReferentialStore().OppStates = localthis.sortArrayByKey(opst, 'label')
      })
    const err5 = await AxiosCallPostWithErr('lynxapi/referential/customerstates', null,
      (res) => {
        ReferentialStore().CustomerStates = res
      })
    return err1 || err2 || err3 || err4 || err5
  }
}
